export function dailySessionReset() {
  const today = new Date().toISOString().split('T')[0]; // e.g. "2025-10-08"
  const lastCleanup = localStorage.getItem('lastCleanupDate');

  if (lastCleanup !== today) {
    // Clear storages
    localStorage.clear();
    sessionStorage.clear();

    // Clear cookies
    document.cookie.split(';').forEach(cookie => {
      document.cookie = cookie
        .replace(/^ +/, '')
        .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
    });

    // Mark cleanup as done
    localStorage.setItem('lastCleanupDate', today);

    // Force full reload to ensure fresh assets (bypass cache)
    // Cache Busting Reload
    window.location.href = window.location.origin + '?t=' + Date.now();
  }
}
